import * as z from "zod";

import { issueCommentSchema } from "./issue-comment";
import { userSchema } from "./user";

export const issueCommentWithCreatedBySchema = issueCommentSchema.extend({
  createdBy: userSchema,
});

export type IssueCommentWithCreatedBy = z.infer<
  typeof issueCommentWithCreatedBySchema
>;
